import path from 'node:path'
import type { ApiRoutesScaffoldOptions } from '@cli-types/next-adapter/init.js'
import { ensureDir, safeWriteFile } from '@cli-utils/files.js'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace/apply-admin-namespace-to-content.js'
import { applyNextCacheApiForVersion } from '@next-adapter/template-reader/apply-next-cache-api-for-version.js'
import { readTemplate } from '@next-adapter/template-reader/read-template.js'

export function scaffoldApiRoutes({ cwd, config }: ApiRoutesScaffoldOptions): string[] {
  const created: string[] = []
  const apiDir = path.resolve(cwd, config.paths.api)
  const namespace = config.frameworkConfig.next.namespace

  function write(relPath: string, content: string): void {
    const fullPath = path.join(apiDir, relPath)
    ensureDir(path.dirname(fullPath))
    const versionedContent = applyNextCacheApiForVersion(content, config.nextMajorVersion)
    if (safeWriteFile(fullPath, applyAdminNamespaceToContent(versionedContent, namespace))) {
      created.push(path.join(config.paths.api, relPath))
    }
  }

  write(path.join('auth', '[...all]', 'route.ts'), readTemplate('api/auth-route.ts'))
  write(path.join('upload', 'route.ts'), readTemplate('api/upload-route.ts'))
  write(path.join('storage', '[key]', 'route.ts'), readTemplate('api/storage-read-route.ts'))

  return created
}
